import React from 'react';
import styled from 'styled-components';

const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export default FlexRow;
